module.exports = __webpack_public_path__ + "img/imagen9.b55405e4.png";